import React from "react";
import { LuCheck, LuLoader } from "react-icons/lu";
import { MdError } from "react-icons/md";

interface AppDialogProps {
  children?: React.ReactNode;
  type: "error" | "success" | "warning" | "info" | "loader" | "custom";
  text?: string;
  title?: string;
  onClose?: () => void;
  onAccept?: () => void;
  onCloseText?: string;
  onAcceptText?: string;
}

const AppDialog: React.FC<AppDialogProps> = ({
  children,
  type,
  text,
  title,
  onClose,
  onAccept,
  onCloseText,
  onAcceptText,
}) => {
  return (
    <div className="fixed inset-0 bg-black/50  flex justify-center items-center z-[1000]">
      <div className="bg-white m-3 p-8 rounded-lg min-w-[400px]">
        {type !== "custom" ? (
          <div className="text-center">
            <div>
              <div className="grid place-content-center mb-4">
                {type === "error" ? (
                  <MdError className="w-10 h-10 text-red-500" />
                ) : type === "success" ? (
                  <div className="w-20 h-20 bg-green-100 rounded-full grid place-content-center">
                    <LuCheck className="w-10 h-10 text-green-500" />
                  </div>
                ) : type === "warning" ? (
                  <></>
                ) : type === "loader" ? (
                  <LuLoader className="w-10 h-10 animate-spin" />
                ) : (
                  <></>
                )}
              </div>
              <div className="text-xl font-bold mb-4">{title}</div>
              <div>{text}</div>
            </div>
            <div className="mt-5 space-x-4">
              {onClose && (
                <button
                  className="bg-red-500 text-white p-2 px-4 rounded"
                  onClick={() => {
                    onClose();
                  }}
                >
                  {onCloseText ? onCloseText : "Close"}
                </button>
              )}
              {onAccept && (
                <button
                  className="bg-blue-500 text-white p-2 px-4 rounded"
                  onClick={() => {
                    onAccept();
                  }}
                >
                  {onAcceptText ? onAcceptText : "Okay"}
                </button>
              )}
            </div>
          </div>
        ) : (
          <div>
            <div>{children}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AppDialog;
